import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../../utils';
export function ModalContent({ children, className }) {
    return (_jsx("div", { className: cn('overflow-y-auto p-stack-section text-left w-full', className), children: children }));
}
